import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden ${className}`} data-id="element-221">
      <div className={noPadding ? '' : 'p-6'} data-id="element-222">{children}</div>
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`mb-4 ${className}`} data-id="element-223">{children}</div>;
}
export function CardTitle({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h3 className={`text-lg font-semibold text-slate-900 ${className}`} data-id="element-224">
      {children}
    </h3>;
}
export function CardDescription({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <p className={`text-sm text-slate-500 ${className}`} data-id="element-225">{children}</p>;
}
export function CardContent({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={className} data-id="element-226">{children}</div>;
}
export function CardFooter({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`mt-6 pt-4 border-t border-slate-100 ${className}`} data-id="element-227">
      {children}
    </div>;
}